import React, { useRef, useEffect, useState } from 'react'
import LALAudioEngine from  './LALAudioEngine'


import * as THREE from "three"
import OrbitControls  from "orbit-controls-es6"
import CameraControls from 'camera-controls';

import Video0102 from './assets/video/0102.mp4'
import Video0304 from './assets/video/0304.mp4'

import LALVideoView from './LALVideoView'

import ReactInputPosition from "react-input-position"
import { MOUSE_ACTIVATION, TOUCH_ACTIVATION } from 'react-input-position/dist/constants'

//--------------------------------------------------------------------
//
//--------------------------------------------------------------------


CameraControls.install( { THREE: THREE } );


//--------------------------------------------------------------------
//
//--------------------------------------------------------------------
export const LALThreeEngine = () => {

  const [viewsLoaded, setViewsLoaded] = useState(false);
  const [audioLoaded, setAudioLoaded] = useState(false);
  const [audioLevel, setAudioLevel] = useState(0);

  const mount = useRef(null)
  const play = useRef(null)

  let views = useRef(null)
  
  const InputInfo = props => {
    // const {
    //   active,
    //   activePosition,
    // } = props

    useEffect(() => {
      if(views.current !== null){
        for(let [,v] of views.current){
          v.props = props
        }
      }
    },[props])
    // let t = "three engine :"

    return <div>
        {/* {active ? t+"yes" : t+"no"} : x={activePosition.x} y={activePosition.y} */}
      </div>
  
  }
  
  useEffect(() => {
    
    console.log("three engine")
    
    const renderer = new THREE.WebGLRenderer()
    const scene = new THREE.Scene()
    const camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, 1, 2000 )
    const controls = new OrbitControls( camera, renderer.domElement)
    
    views.current = new Map()

    // let col = "#000000"
    renderer.setSize( window.innerWidth, window.innerHeight-199)
    // renderer.setClearColor(col)
    // renderer.autoClear = false
    // renderer.autoClearColor = false 
    // renderer.autoClearDepth = false
    
    
    
    scene.background = new THREE.Color('black')

    controls.enableDamping = false
    controls.dampingFactor = 0.01
    controls.enabled = false
    controls.update()

    camera.position.z = 3.3

    // append DOM element before we load the videos else
    // videos will not load on first onLo1ad
    mount.current.appendChild(renderer.domElement)

    views.current.set(
      Video0102, new LALVideoView(scene, Video0102, () => {
        views.current.set(Video0304, new LALVideoView(scene, Video0304, () => { 
            setViewsLoaded(true)
      }))
      })
    )


    play.current = (now) => {
      let i = 0
      for(let [,v] of views.current){
        v.animate(now,i)
        i += 0.17
      }

      
      controls.update()
      renderer.render( scene, camera )
      // setTimeout( function() {
        requestAnimationFrame( play.current )
      //  }, 1000 / 10 )
      // onRender(now)
  }

    
  
  },[])
  
  useEffect(() => {
    if(viewsLoaded && audioLoaded){
      play.current()
    }
  },[viewsLoaded, audioLoaded])

  useEffect(() => {

    for(let [,v] of views.current){
      v.level = audioLevel
    }
  },[audioLevel, views])


  const ts = {
    top: ((window.innerHeight) / 2) + "px"
}

  return (
    <div>

      <ReactInputPosition
        mouseActivationMethod={MOUSE_ACTIVATION.MOUSE_DOWN}
        touchActivationMethod={TOUCH_ACTIVATION.TOUCH}
        trackPreviousPosition={true}
        trackPassivePosition={false}
        trackItemPosition={false}
        cursorStyle="move"
      >
        <InputInfo />

        <div id="info" style={ ts }>{viewsLoaded && audioLoaded? <br/> : "please wait while loading..."}</div>

        <LALAudioEngine onLoad={ () => {setAudioLoaded(true)}} onLevel={ (l) => { setAudioLevel(l) }}/>
    
        <p className="title">Layer Upon Layer</p>
       <div ref={ mount } />
    
      </ReactInputPosition>
    
    </div>
  )

}

export default LALThreeEngine;